import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { ProcessRefundService } from "src/app/services/process-refund.service";
import { RefundReportDetailsModel } from "src/app/model/RefundReportDetailsModel";
import { Console } from "console";

@Component({
  selector: "app-secure-process-refund",
  templateUrl: "./process-refund.component.html",
  styleUrls: ["./process-refund.component.scss"],
})
export class ProcessRefundComponent implements OnInit {
  isLoading = false;
  lotteries: {[key: number]: string};
  lotteryKey: {key: number, value: string};
  refundReportDetailKey: number;
  lotteryStage: string;
  refundReportDetail:  RefundReportDetailsModel[] = [];
  status: string;
  error: string;
  
  constructor(
    private router: Router,
    private modalCtrl: ModalController,
    private processRefundService: ProcessRefundService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.processRefundService.initProcessRefundForm().subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.lotteries = data.lotteries;
        }
        else {
          this.processRefundService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.processRefundService.errorToast(error?.error?.message || error?.error?.errorMessage);
        this.isLoading = false;
      }
    );
  }

  processRefundForLottery(){
    console.log("Selected Lottery Key", this.lotteryKey.key);
    this.processRefundService.initiateRefundProcess(this.lotteryKey.key).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.status = data.status;
          this.processRefundService.successToast(data.successMsg);
          window.location.reload();
          // this.router.navigate(["/secure", "/process-refund"]);
          // setTimeout(() => {
          //   this.ngOnInit();
          // }, 2000);
        }
        else {
          this.processRefundService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.processRefundService.errorToast(error?.error?.message || error?.error?.errorMessage);
        this.isLoading = false;
      }
      );
  }

  onLotteryChange(e: any) {
    this.lotteryKey.key = e.key;
    this.lotteryStage = null;
    this.refundReportDetail = [];
    if(e?.key > 0) {
      this.isLoading = true;
      this.processRefundService.initWithLottery(e.key).subscribe((data) => {
          this.isLoading = false;
          if(data.status === 'SUCCESS') {
            this.lotteryStage = data.lotteryStage;
            this.refundReportDetail = data.refundReportDetail;  
          }
          else {
            this.processRefundService.errorToast(data.errorMessage);
          }
        },
        (error) => {
          this.processRefundService.errorToast(error?.error?.message || error?.error?.errorMessage);
          this.isLoading = false;
        }
      );
    }
  }

  downloadRefundReport(e: number){
    this.refundReportDetailKey = e;
     if(this.refundReportDetailKey >0){
      this.isLoading = true;
      this.processRefundService.getRefundReportFile(this.refundReportDetailKey).subscribe((data) => {
          this.isLoading = false;
          if(data.status === 'SUCCESS'){
            console.log('SUCCESS');
          }else{
            this.processRefundService.errorToast(data.errorMessage);
          }
        },
        (error) => {
          this.processRefundService.errorToast(error?.error?.message || error?.error?.message);
          this.isLoading = false;
        }
      );
     }
  }

  async viewRefundReport(e: number) {
    this.refundReportDetailKey = e;
    this.processRefundService.getRefundReportFile(this.refundReportDetailKey)
    .subscribe(async (data) => {
        if(data.status === 'SUCCESS') {
            this.downloadFile(data.base64File, data.fileName);
        }
        else {
            this.processRefundService.errorToast(data.errorMessage);
        }
    });
  }

  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `data:text/xlsx;base64,${base64}`;
    const link = document.createElement("a")
    link.href = src
    link.download = fileName
    link.click()
    
    link.remove()
  }

}